export default function (Vue) {
  Vue.directive('validate', directive)
}

const directive = {
  bind (el, binding) {
    el.addEventListener('input', inputEvent)
    el.addEventListener('change', inputEvent)
    el.addEventListener('blur', inputEvent)
    el._vue_rw_validator = new Validator(binding.modifiers, binding.value)
    el.validate = (updateClasses) => doValidation(el, updateClasses)
  },
  unbind (el) {
    el.removeEventListener('input', inputEvent)
    el.removeEventListener('change', inputEvent)
    el.removeEventListener('blur', inputEvent)
    delete el.validate
    delete el._vue_rw_validator
  }
}

function doValidation (el, updateClasses = true) {
  let res = el._vue_rw_validator.validate(el.value, el)
  if (updateClasses) {
    if (res) {
      el.classList.add('valid')
      el.classList.remove('invalid')
    } else {
      el.classList.add('invalid')
      el.classList.remove('valid')
    }
  }
  return res
}

function inputEvent (event) {
  doValidation(event.target, true)
}

class Validator {
  constructor (modifiers, value) {
    this.options = value
    this.validators = []
    for (const name in this.availableValidators) {
      if (modifiers[name] === true) {
        this.validators.push(name)
      }
    }
  }

  availableValidators = {
    email: function (value) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(String(value).toLowerCase())
    },
    numeric (value) {
      return !isNaN(value)
    },
    range (value, options) {
      if (isNaN(value)) {
        return false
      }
      if (options.min && value < options.min) {
        return false
      }
      if (options.max && value > options.max) {
        return false
      }
      return true
    },
    required (value) {
      return Boolean(value && (value.length > 0))
    },
    checked (_1, _2, el) {
      return el.checked
    }
  }

  validate (value, el) {
    for (const name of this.validators) {
      let res = this.availableValidators[name](value, this.options, el)
      if (res === false) {
        return false
      }
    }
    return true
  }
}



// WEBPACK FOOTER //
// ./src/Validation.js